import {
  LabelInput,
  EntryTypeSelect,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const LinkStyleToggle = {
  label: 'Style',
  settingType: 'radioButton',
  updateType: 'entry',
  property: 'style',
  choices: [
    { label: 'Button', value: 0 },
    { label: 'Link', value: 1 },
  ],
}

const LinkUrlInput = {
  label: 'URL',
  settingType: 'textInput',
  updateType: 'entry',
  property: 'default',
}

const ButtonTextInput = {
  label: 'Button Text',
  settingType: 'textInput',
  updateType: 'entry',
  property: 'mask',
}

export const LinkStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  LinkStyleToggle,
  LinkUrlInput,
]

export const ButtonLinkStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  LinkStyleToggle,
  LinkUrlInput,
  ButtonTextInput,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
